import React from 'react';

import BarChart from '@/features/common/components/BarChart';
import { BrakeSideData, Status } from '@/generated/GeneratedApiTypes';

type BrakeLiningBarChartProps = Partial<BrakeSideData>;
const BrakeLiningBarChart: React.FC<BrakeLiningBarChartProps> = ({ status, value }: BrakeLiningBarChartProps) => {
    if (typeof value !== 'number') {
        return <div>-</div>;
    }

    return <BarChart value={value} status={status ?? Status.NORMAL} />;
};

export default BrakeLiningBarChart;
